module.exports = __webpack_public_path__ + "static/rents-d005b2d84f1c8597172b728a1974b81f.png";